import React from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'
import StyledTitle from './styled/title'

// 提示框标题
export default function Title({ text, type, theme }) {
  if (typeof text === 'string') {
    return (
      <StyledTitle type={type} theme={theme}>
        <Icon type={type} theme={theme} />
        {text}
      </StyledTitle>
    )
  }
  return text
}

Title.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  theme: PropTypes.shape,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
}

Title.defaultProps = {
  text: null,
  theme: {},
  type: 'info',
}
